import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideSecondaryPanel } from 'store/productManagement/reducer';
import { Store } from 'components/common/types/Store.types';
import { PlannerSecondaryPanelType } from 'store/dealManagement/types';
import { changePlannerSecondaryPanelType } from 'store/dealManagement/reducer';
import { SelectionPermission } from 'store/productManagement/reducer.types';
import { defaultValuePermissionOptions } from 'components/pages/PCM/Products/consts';
import SelectionPermissionDropdown from 'components/pages/PCM/Products/ProductFields/SelectionPermissionDropdown/SelectionPermissionDropdown';
import { secondaryPanelLayoutStyles } from '../../styles';
import { isValueRequired } from '../../utils/isValueRequired';
import { ProductObjectivesPanelProps } from './ProductObjectivesPanel.types';
import { ProductSecondaryPanel } from '../ProductSecondaryPanel/ProductSecondaryPanel';

const ProductObjectivesPanel: React.FC<ProductObjectivesPanelProps> = ({ onConfirm, isReadOnly = false }) => {
  const dispatch = useDispatch();
  const objectivesPermission = useSelector(
    (state: Store) => state.productManagement.newProduct?.objectives.selectionPermission,
  );

  const defaultSelectedPermission =
    defaultValuePermissionOptions.find(({ code }) => code === objectivesPermission) ?? defaultValuePermissionOptions[0];
  const [selectedPermission, setSelectedPermission] = useState<{
    code: SelectionPermission;
    name: string;
  }>(defaultSelectedPermission);

  const onSelect = (permission: { code: SelectionPermission; name: string }): void => {
    setSelectedPermission(permission);

    if (permission.code === SelectionPermission.FIXED_VALUE || permission.code === SelectionPermission.DEFAULT_VALUE) {
      dispatch(changePlannerSecondaryPanelType(PlannerSecondaryPanelType.OBJECTIVE));
    }
  };

  const isConfirmDisabled =
    isReadOnly || (objectivesPermission === selectedPermission.code && !isValueRequired(selectedPermission.code));

  const handleCancel = (): void => {
    dispatch(hideSecondaryPanel());
  };

  return (
    <ProductSecondaryPanel
      title="Objective"
      onSubmit={() => onConfirm({ selectedPermission })}
      onCancel={handleCancel}
      isDisabled={isConfirmDisabled}
      customStyles={secondaryPanelLayoutStyles}
      confirmButtonLabel={
        [SelectionPermission.DEFAULT_VALUE, SelectionPermission.FIXED_VALUE].includes(selectedPermission.code)
          ? 'Next'
          : 'Save'
      }
    >
      <SelectionPermissionDropdown
        selectedPermission={selectedPermission}
        setSelectedPermission={onSelect}
        permissionOptions={defaultValuePermissionOptions}
      />
    </ProductSecondaryPanel>
  );
};

export default ProductObjectivesPanel;
